import { Link } from 'react-router-dom';
import { Logomark } from './public-nav';

export function PublicFooter() {
  return (
    <footer className="relative mt-32 border-t border-ink/10 bg-cream-100 dark:bg-ink-soft">
      <div className="container-wide py-20">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <Logomark className="h-10 w-10 text-primary" />
              <div>
                <div className="font-display text-xl">Gracefully Rebuilt</div>
                <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground">
                  from broken to blessed
                </div>
              </div>
            </div>
            <p className="mt-6 max-w-sm text-pretty font-display text-xl italic leading-snug text-foreground/80">
              “He heals the brokenhearted and binds up their wounds.”
              <span className="mt-1 block text-xs not-italic uppercase tracking-[0.2em] text-muted-foreground">
                Psalm 147:3
              </span>
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 md:col-span-7 md:grid-cols-3">
            <FooterCol
              title="Explore"
              links={[
                { to: '/catalog', label: 'Courses' },
                { to: '/sisterhood', label: 'Sisterhood' },
                { to: '/start-journey', label: 'Start your journey' },
                { to: '/pricing', label: 'Pricing' },
              ]}
            />
            <FooterCol
              title="Resources"
              links={[
                { to: '/devotional', label: 'Free 7-day devotional' },
                { to: '/blog', label: 'Reflections blog' },
                { to: '/contact', label: 'Contact us' },
                { to: '/faq', label: 'FAQ' },
              ]}
            />
            <FooterCol
              title="Legal"
              links={[
                { to: '/privacy', label: 'Privacy' },
                { to: '/terms', label: 'Terms' },
                { to: '/cookies', label: 'Cookies' },
              ]}
            />
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-ink/10 pt-8 text-sm text-muted-foreground md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} Gracefully Rebuilt. All rights reserved.</p>
          <p className="italic">Walking with you, step by step.</p>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({
  title,
  links,
}: {
  title: string;
  links: { to: string; label: string }[];
}) {
  return (
    <div>
      <div className="eyebrow">{title}</div>
      <ul className="mt-4 space-y-3">
        {links.map((l) => (
          <li key={l.to}>
            <Link
              to={l.to}
              className="text-sm text-foreground/80 transition-colors hover:text-primary"
            >
              {l.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
